const JST_OFFSET_MS = 9 * 60 * 60 * 1000;
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const pad = (n) => String(n).padStart(2, '0');

function shiftedToJst(iso) {
  const d = new Date(new Date(iso).getTime() + JST_OFFSET_MS);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function toJstInput(iso) {
  const d = iso ? shiftedToJst(iso) : null;
  if (!d) return '';
  return `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())}T${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}`;
}

export function fromJstInput(value) {
  if (!value) return null;
  const withSeconds = value.length === 16 ? `${value}:00` : value;
  const d = new Date(`${withSeconds}+09:00`);
  return Number.isNaN(d.getTime()) ? null : d.toISOString();
}

export function formatJst(iso) {
  const d = iso ? shiftedToJst(iso) : null;
  if (!d) return '';
  return `${MONTHS[d.getUTCMonth()]} ${d.getUTCDate()}, ${d.getUTCFullYear()}, ${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())} JST`;
}

export function formatUtc(iso) {
  const d = iso ? new Date(iso) : null;
  if (!d || Number.isNaN(d.getTime())) return '';
  return `${d.toISOString().slice(0, 10)} ${d.toISOString().slice(11, 16)} UTC`;
}
